export default "__VITE_ASSET__DiVrUCew__"